import React, {ReactNode, ReactNodeArray} from 'react';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import TechnicianUpdatesBlockData from '../../../Models/Content/TechnicianUpdatesBlockData';
import TechnicianUpdates from './TechnicianUpdates';

export default class TechnicianUpdatesBlock extends EpiComponent<TechnicianUpdatesBlockData> {
  public render(): ReactNode | ReactNodeArray | null {
    let cssClasses: Array<string> = ['sale-block'];
    if (this.props.data.padding?.value) cssClasses.push(this.props.data.padding?.value);
    if (this.props.data.margin?.value) cssClasses.push(this.props.data.margin?.value);

    return (
      <div className={cssClasses.join(" ")}>
          <TechnicianUpdates iContent={this.props.data} context={this.getContext()} />  
      </div>          
    )
  }
}
